import React from "react";

const SuccessCheckIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M1.28906 7.99627C1.28906 4.29198 4.29198 1.28906 7.99627 1.28906C11.7006 1.28906 14.7035 4.29198 14.7035 7.99627C14.7035 11.7006 11.7006 14.7035 7.99627 14.7035C4.29198 14.7035 1.28906 11.7006 1.28906 7.99627ZM11.5931 6.18766C11.7883 5.9924 11.7883 5.67582 11.5931 5.48055C11.3978 5.28529 11.0812 5.28529 10.886 5.48055L6.91519 9.45132L5.10658 7.64272C4.91132 7.44745 4.59474 7.44745 4.39947 7.64272C4.20421 7.83798 4.20421 8.15456 4.39947 8.34982L6.56164 10.512C6.7569 10.7072 7.07348 10.7072 7.26874 10.512L11.5931 6.18766Z"
        fill="#78B856"
      />
    </svg>
  );
};

export default SuccessCheckIcon;
